import { Box, Grid, Paper } from "@mui/material";
import {
  ChartContainer,
  ChartsXAxis,
  ChartsYAxis,
  LinePlot,
  BarPlot,
  AllSeriesType,
  MarkPlot,
  LineHighlightPlot,
  ChartsTooltip,
  ChartsGrid,
} from "@mui/x-charts";

export enum SCALE_TYPES {
  TIME = "time",
  BAND = "band",
  LINEAR = "linear",
}

interface ChartProps {
  title?: string;
  xData: Array<any>;
  yData: Array<number>;
  xDataFormatter: Function;
  yDataFormatter?: Function;
  scaleType: SCALE_TYPES;
  bars?: boolean;
}

const Chart = ({
  title,
  xData,
  yData,
  xDataFormatter,
  scaleType: selectedST,
  yDataFormatter,
  bars,
}: ChartProps) => {
  const elements = bars
    ? {
        id: "bar",
        type: "bar",
        data: yData,
        valueFormatter: (value: any) =>
          yDataFormatter ? yDataFormatter(value) : value,
        color: "#4663ff",
      }
    : {
        id: "main",
        type: "line",
        curve: "linear",
        data: yData,
        valueFormatter: (value: any) =>
          yDataFormatter ? yDataFormatter(value) : value,
        area: true,
        color: "#4663ff",
      };

  const config = {
    series: [elements] as AllSeriesType[],
    xAxis: [
      {
        scaleType: selectedST,
        data: xData,
        valueFormatter: (value: any) => xDataFormatter(value),
      },
    ],
    sx: {
      ".MuiLineElement-root": {
        stroke: "#4663ff",
        strokeWidth: 2,
      },
      "& .MuiAreaElement-root": {
        fill: "rgba(160, 126, 218, 0.8)",
      },
      ".MuiMarkElement-root": {
        stroke: "#4663ff",
        scale: "0.75",
        fill: "#fff",
        strokeWidth: 2,
      },
      "& .MuiChartsAxis-left .MuiChartsAxis-tickLabel": {
        fontWeight: "700 !important",
      },
      "& .MuiChartsAxis-bottom .MuiChartsAxis-tickLabel": {
        fontWeight: "700 !important",
      },
    },
  };

  return (
    <Grid container sx={{ width: "100%" }}>
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100% !important", height: 300 }} elevation={0}>
          <ChartContainer {...config}>
            <ChartsGrid vertical horizontal />
            {bars ? (
              <BarPlot />
            ) : (
              <>
                <LinePlot />
                <MarkPlot />
                <LineHighlightPlot />
                {/* <AreaPlot /> */}
              </>
            )}
            <ChartsTooltip />
            <ChartsXAxis />
            <ChartsYAxis />
          </ChartContainer>
        </Paper>
      </Box>
    </Grid>
  );
};

export default Chart;
